import React, { createContext, useCallback, useMemo, useState } from 'react';
import ConfirmModal from '../../components/modals/ConfirmModal/ConfirmModal';

/**
 * @typedef TConfirmProvider
 * @type {{
 *  title?: string;
*   message?: string;
*   confirmText?: string;
*   cancelText?: string;
*   onConfirm?: () => void;
*   onCancel?: () => void;
 * }}
 */

/**
 * @typedef TConfirmProviderContext
 * @type {{
 *  show: (confirmOptions: TConfirmProvider | null) => void
 * }}
 */

export const ConfirmCtx = createContext(/** @type {TConfirmProviderContext|null} */(null));

export function ConfirmProvider({ children }) {
  const [confirm, setConfirm] = useState(/** @type {TConfirmProvider|null} */(null));
  const [open, toggle] = useState(false);
  const show = useCallback(
    (/** @type {TConfirmProvider | null} */ confirmOptions) => {
      setConfirm(confirmOptions);
      toggle(true);
    },
    []
  );
  const onConfirm = () => {
    confirm?.onConfirm?.();
    toggle(false);
  };
  const onCancel = () => {
    confirm?.onCancel?.();
    toggle(false);
  };
  const value = useMemo(() => ({ show }), [show]);
  return (
    <ConfirmCtx.Provider value={value}>
      <ConfirmModal
        show={open}
        title={confirm?.title || 'Unsaved Changes'}
        confirmModalInfo={confirm?.message || 'You have unsaved changes. Are you sure you want to leave?'}
        buttonConfirmText={confirm?.confirmText || 'Leave'}
        buttonCancelText={confirm?.cancelText || 'Stay'}
        onClose={(modalResponse) => {
          if (modalResponse.result) {
            onConfirm();
          } else {
            onCancel();
          }
        }}
      />
      {children}
    </ConfirmCtx.Provider>
  );
}
